import { render, staticRenderFns } from "./warrantySticky.pug?vue&type=template&id=39123f72&lang=pug&"
import script from "./warrantySticky.js?vue&type=script&lang=js&"
export * from "./warrantySticky.js?vue&type=script&lang=js&"
import style0 from "./warrantySticky.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39123f72')) {
      api.createRecord('39123f72', component.options)
    } else {
      api.reload('39123f72', component.options)
    }
    module.hot.accept("./warrantySticky.pug?vue&type=template&id=39123f72&lang=pug&", function () {
      api.rerender('39123f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warrantyLayout/components/warrantySticky/index.vue"
export default component.exports